import { Component, OnInit } from '@angular/core';
import { ComponentsService } from "src/app/components.service";

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  constructor(private service: ComponentsService) { }

  private loading: boolean = false;

  private loadingTickets;
  private loadingTicketsStatistic;
  private loadingTicketsNum;
  private loadingUsers;
  private loadingPos;
  private loadingStatisticSlots;

  private loadingSlotsStatistic;
  private loadingSlotsGamePlay;
  private loadingSlotsNum;

  private isLoadingTickets: boolean = false;
  private isLoadingTicketsNum: boolean = false;
  private isLoadingTicketsStatistic: boolean = false;
  private isLoadingUsers: boolean = false;
  private isLoadingPos: boolean = false;
  private isLoadingSlotsStatistic: boolean = false;
  private isLoadingSlotsGamePlay: boolean = false;
  private isLoadingSlotsNum: boolean = false;

  ngOnInit(): void {
    this.loadingTickets = this.service.loadingTickets.subscribe(
      (e) => {
        this.isLoadingTickets = !e.loaded;
        this.checkIsLoading();
      }
    );
    this.loadingTicketsNum = this.service.loadingTicketsNum.subscribe(
      (e) => {
        this.isLoadingTicketsNum = !e.loaded;
        this.checkIsLoading();
      }
    );
    this.loadingTicketsStatistic = this.service.loadingTicketsStatistic.subscribe(
      (e) => {
        this.isLoadingTicketsStatistic = !e.loaded;
        this.checkIsLoading();
      }
    );
    this.loadingUsers = this.service.loadingUsers.subscribe(e => {
      this.isLoadingUsers = !e.loaded;;
      this.checkIsLoading();
    })
    this.loadingPos = this.service.loadingPos.subscribe(e => {
      this.isLoadingPos = !e.loaded;
      this.checkIsLoading();
    })

    this.loadingSlotsGamePlay = this.service.loadingSlotsGamePlay.subscribe(
      (e) => {
        this.isLoadingSlotsGamePlay = !e.loaded;
        this.checkIsLoading();
      }
    );
    this.loadingSlotsNum = this.service.loadingSlotsNum.subscribe(
      (e) => {
        this.isLoadingSlotsNum = !e.loaded;
        this.checkIsLoading();
      }
    );
    this.loadingSlotsStatistic = this.service.loadingSlotsStatistic.subscribe(
      (e) => {
        this.isLoadingSlotsStatistic = !e.loaded;
        this.checkIsLoading();
      }
    );

  }


  checkIsLoading() {
    let loading = this.isLoadingTickets || this.isLoadingTicketsNum || this.isLoadingTicketsStatistic ||
      this.isLoadingUsers || this.isLoadingPos || this.isLoadingSlotsStatistic ||
      this.isLoadingSlotsStatistic || this.isLoadingSlotsGamePlay || this.isLoadingSlotsNum;
    this.setLoading(loading);
  }

  //KADA SE MENJA KLIJENT (  SUPER ADMIN );
  ngOnDestroy() {
    if (this.loadingTickets) {
      this.loadingTickets.unsubscribe();
    }
    if (this.loadingTicketsNum) {
      this.loadingTicketsNum.unsubscribe();
    }
    if (this.loadingTicketsStatistic) {
      this.loadingTicketsStatistic.unsubscribe();
    }
    if (this.loadingUsers) {
      this.loadingUsers.unsubscribe();
    }
    if (this.loadingPos) {
      this.loadingPos.unsubscribe();
    }
    if (this.loadingStatisticSlots) {
      this.loadingStatisticSlots.unsubscribe();
    }
    if (this.loadingSlotsStatistic) {
      this.loadingSlotsStatistic.unsubscribe();
    }
    if (this.loadingSlotsGamePlay) {
      this.loadingSlotsGamePlay.unsubscribe();
    }
    if (this.loadingSlotsNum) {
      this.loadingSlotsNum.unsubscribe();
    }
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  getLoading(): boolean {
    return this.loading;
  }

}
